export default __webpack_public_path__ + "static/media/Amarécomplexo.a7a37132.jpg";